<template>
  <div
    class="tw-mx-4 tw-flex tw-h-9 tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-dorian-gray-100 tw-pl-4"
  >
    <PopoverRoot>
      <PopoverTrigger
        :disabled="disabled"
        class="tw-w-[36px] tw-h-9 tw-inline-flex tw-items-center tw-justify-center bg-white shadow-sm border hover:bg-stone-50 cursor-default focus:shadow-[0_0_0_2px] focus:shadow-black dark:focus:shadow-green8 focus:outline-none"
        :class="{ 'tw-text-dorian-gray-200': disabled }"
      >
        <cl-icon-tabler-columns-3 />
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          class="tw-z-[60] tw-m-1 tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-shadow-md tw-will-change-[transform,opacity]"
          :side="'bottom'"
          :align="'end'"
        >
          <div class="tw-font-medium tw-text-base tw-p-3">
            {{ "Configure columns" }}
          </div>
          <ul class="tw-p-3 tw-pt-0 tw-border-b tw-border-dorian-gray-100">
            <slot />
          </ul>
          <template v-if="resetBtn">
            <div class="tw-py-2.5 tw-pl-2.5 tw-pr-4">
              <cl-button
                @on-click="emit('reset')"
                :disabled="resetBtn.disabled"
                fullwidth
                :variant="'secondary'"
              >
                <span class="tw-mr-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-restore"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3.06 13a9 9 0 1 0 .49 -4.087" />
                    <path d="M3 4.001v5h5" />
                    <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                  </svg>
                </span>
                {{ resetBtn.label ?? "Reset Order" }}
              </cl-button>
            </div>
          </template>
        </PopoverContent>
      </PopoverPortal>
    </PopoverRoot>
  </div>
</template>

<script lang="ts">
type ResetButton = {
  disabled: boolean;
  label?: string;
};

interface Props {
  resetBtn?: ResetButton;
  disabled?: boolean;
}
</script>

<script setup lang="ts">
import { toRefs } from "vue";
import {
  PopoverContent,
  PopoverPortal,
  PopoverRoot,
  PopoverTrigger,
} from "reka-ui";

const props = withDefaults(defineProps<Props>(), { disabled: false });
const { resetBtn } = toRefs(props);

const emit = defineEmits<{
  (event: "reset"): void;
}>();
</script>
